import { DataBean } from "../DataBean";


export class FormParamDinamic extends DataBean {

    public async getFormParamCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getFormParamCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async deleteFormParam(idFormParam: number): Promise<any> {
        return this.getCustomService("Forms", "boolean_deleteFormParam_Number", [idFormParam]);
    }

    public async getFormAtributesByCode(idFormCode: number): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getFormAtributesByCode_Number", [idFormCode]);
    }

    public async updateFormParam(bean: any): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.FormParam_updateFormParam_com.advantage.forms.bean.FormParam", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.FormParam"
            }
        ]);
    }

}